/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onlogoutCognitoUser = /* GraphQL */ `subscription OnlogoutCognitoUser($cognitousername: String!) {
  onlogoutCognitoUser(cognitousername: $cognitousername) {
    sessionid
    cognitousername
    logintimestamp
    logouttimestamp
    linkedsessionid
    deviceinfo
    ipaddress
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnlogoutCognitoUserSubscriptionVariables,
  APITypes.OnlogoutCognitoUserSubscription
>;
export const onfreezeFinancialYear = /* GraphQL */ `subscription OnfreezeFinancialYear($companyid: Int!) {
  onfreezeFinancialYear(companyid: $companyid) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnfreezeFinancialYearSubscriptionVariables,
  APITypes.OnfreezeFinancialYearSubscription
>;
export const onunFreezeFinancialYear = /* GraphQL */ `subscription OnunFreezeFinancialYear($companyid: Int!) {
  onunFreezeFinancialYear(companyid: $companyid) {
    financialyearid
    companyid
    companybranchid
    enteredtimestamp
    expiredtimestamp
    startdate
    enddate
    startyear
    endyear
    comments
    userid
    aliasname
    statuscode
    statusmessage
    freezestatus
    transferdate
    freezedate
    stepscompleted
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnunFreezeFinancialYearSubscriptionVariables,
  APITypes.OnunFreezeFinancialYearSubscription
>;
export const onNewAppVersion = /* GraphQL */ `subscription OnNewAppVersion {
  onNewAppVersion {
    id
    version_number
    release_notes
    release_date
    is_mandatory
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnNewAppVersionSubscriptionVariables,
  APITypes.OnNewAppVersionSubscription
>;
